
import styled from 'styled-components';
import { maxMobile, primaryFont, smMobile, wMedium } from '../../../Utils/utilsStyle';
import { Divider } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { selectProductAndServicesLoading } from '../../../Selector/CompaniesSelector';
import SkeletonCustom from '../../common/skeleton/SkeletonCustom';
import { selectClusterProductAndServicesLoading } from '../../../Selector/ClustersSelector';
import CustomRefreshButton from '../../common/components/CustomRefreshButton';
import UpdatedPill from './UpdatedPill';
import { useSearchParams } from 'react-router-dom';
import { actions as companiesActions } from '../../../Slice/CompaniesSlice';
import { actions as clustersActions } from '../../../Slice/ClustersSlice';
import { isXiqUser } from '../../../Utils/UtilityFunctions';

const Wrapper = styled.div`
    background-color:#fff;
    border-radius: 16px;
    box-shadow: 0 0 17px -2px rgba(0, 0, 0, 0.04);
    border-radius:16px;
    position: relative;
    margin-bottom: 21px;
    padding: 16px 22px;
    .product-service-skeleton {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-top: 25px;
    }
    .product-service-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      @media all and (max-width: ${smMobile}) {
        align-items: flex-start;
      }
      .header-icon {
        display: flex;
        align-items: center;
        gap: 7px;
        .head-text {
          font-family: ${primaryFont};
          font-size: 20px;
          font-weight: ${wMedium};
          line-height: normal;
          letter-spacing: -0.455px;
          color: #424B50;
          @media all and (max-width: ${maxMobile}) {
            font-size: 18px;
          }
        }
      }
      .header-refresh {
        display: flex;
        align-items: center;
        gap: 20px;
        .separator {
          display: none;
        }
        @media all and (max-width: ${smMobile}) {
          flex-direction: column-reverse;
          align-items: flex-end;
          gap: 6px;
        }
        .custom-refresh-button {
          display: flex;
          align-items: center;
        }
      }
    }
    .content-container {
    padding: 16px 0;
      .content-item {
        display: flex;
        flex-direction: column;
        .content-title {
          color: #424B50;
          font-size: 16px;
          line-height: 26px;
          letter-spacing: -0.375px;
          font-weight: ${wMedium};
          font-family: ${primaryFont};
          margin-bottom: 6px;
          @media all and (max-width: ${maxMobile}) {
            font-size: 14px;
            line-height: 18px;
            letter-spacing: -0.375px;
          }
        }
        .content-description {
          font-size: 14px;
          line-height: 18px;
          letter-spacing: -0.375px;
          font-weight: ${wMedium};
          color: #7E7E7E;
          font-family: ${primaryFont};
          @media all and (max-width: ${maxMobile}) {
            font-size: 13px;
            line-height: 16px;
          }
        }
        .separator {
          color: #B6B6B6;
          margin: 16px 0;
        }
      }
    }
`;
type ProductServiceItem = {
  name: string;
  description: string;
};

type Props = {
  title: string,
  icon: React.ReactNode,
  items: ProductServiceItem[]
  isCluster?: boolean,
  clusterCompanyId?: number,
  showRefreshButton?: boolean,
  lastUpdateTime?: string,
  showRefreshSection?: boolean,
}
const ProductServiceCard = function ProductServiceCard(props: Props) {
  const { title, icon, items, isCluster, clusterCompanyId, showRefreshButton, lastUpdateTime, showRefreshSection } = props;
  const clusterProductAndServicesLoading = useSelector(selectClusterProductAndServicesLoading)
  const productAndServicesLoading = isCluster ? clusterProductAndServicesLoading[clusterCompanyId ?? 0] : useSelector(selectProductAndServicesLoading);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const companyId = searchParams.get('companyId');
  const companyIdParsed = companyId ? parseInt(companyId, 10) : 0;



  const handleRefresh = () => {
    if (isCluster) {
      dispatch(clustersActions.getClusterProductAndServices({ companyId: clusterCompanyId ?? 0, refresh: 1 }));
    } else {
      dispatch(companiesActions.getProductAndServices({ companyId: companyIdParsed, refresh: 1 }));
    }
  }
  return (
    <Wrapper>
      {productAndServicesLoading ? (
        [1, 2, 3, 4].map(() => (
          <div className='product-service-skeleton'>
            <SkeletonCustom width="240px" height="35px" margin="0px" />
            <SkeletonCustom width="100%" height="30px" margin="0px" />

          </div>
        ))
      ) : (
        <>
          <div className="product-service-head">
            <div className="header-icon">
              {icon}
              <span className="head-text">{title}</span>
            </div>
            {showRefreshSection && isXiqUser() && (
              <div className="header-refresh">
                <UpdatedPill
                  date={lastUpdateTime}
                />
                <CustomRefreshButton
                  onRefresh={handleRefresh}
                  buttonText="Refresh"
                  isCluster={isCluster}
                  clusterCompanyId={clusterCompanyId}
                  disabled={!showRefreshButton}
                />
              </div>
            )}
          </div>
          <div className="content-container">
            {items.map((item, index) => (
              <div className="content-item" key={item.name}>
                <h4 className="content-title">{item.name}</h4>
                <span className="content-description">{item.description}</span>

                {index < items.length - 1 && (
                  <Divider className="separator" />
                )}
              </div>
            ))}
          </div>
        </>
      )}
    </Wrapper>
  )
}

export default ProductServiceCard;